import React, { useState } from "react";
import Select from "react-select";
import {
  sendDataToCloudSigner,
  sendDataToOtherCloudSigner,
} from "../../redux/transaction/transaction.actions";
import { hideCloudCertModal } from "../../redux/cloud-cert-modal/cloud-cert-modal.actions";
import "./cloud-cert-dropdown.styles.scss";

const CloudCertDropdown = ({ user, cloudUser, data, dispatch, tsp }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [password, setPassword] = useState("");

  const { accessToken, idp_level, idp_source, idp_transaction } = user;
  const { documents, token, mimetype, signatureType } = data;

  const title =
    signatureType === "sign"
      ? "Odaberite certifikat za potpisivanje"
      : "Odaberite certifikat za pečatiranje";
  // ovo popraciti da gleda signatureType i ponudi certifikate odnosno pečate

  const sigType = signatureType === "sign" ? "certs" : "seals";

  let options = [];
  if (cloudUser && cloudUser[sigType]) {
    options = cloudUser[sigType].map((cert) => {
      return {
        value: cert.cert_id,
        label: `${cert.certname} - ${cert.certtype} - vrijedi do: ${new Date(
          cert.valid_not_after
        ).toLocaleDateString()}`,
        algver: cert.algver,
        algVerNext: cert.algVerNext,
        certificate: cert.certificate,
      };
    });
  }

  const handleCloseModal = () => {
    dispatch(hideCloudCertModal());
  };

  const handleChange = (optin) => {
    setSelectedOption(optin);
  };

  const handleInputChange = (e) => {
    setPassword(e.target.value);
  };

  const handleOnClick = () => {
    const selectedTsp = tsp.selectedTsp;
    const params = {
      certificateId: selectedOption.value,
      certificate: selectedOption.certificate,
      casid: cloudUser.casid,
      tsp_signer_id: cloudUser.tsp_signer_id,
      idp_level,
      idp_source,
      idp_transaction,
      documents,
      token,
      password,
      algver: selectedOption.algver,
      algVerNext: selectedOption.algVerNext,
      mimetype,
      salt: cloudUser.salt,
      accessToken
    };

    if (password.length <= 5 || !selectedOption) {
      return null;
    }

    if (tsp.selectedTsp.internal) {
      dispatch(sendDataToCloudSigner(params, selectedTsp));
    } else {
      dispatch(sendDataToOtherCloudSigner(params, selectedTsp));
    }

    // if(password.length <= 5 || !selectedOption) {
    //   return null
    // }
    // dispatch(sendDataToCloudSigner(params, tspUrl))
  };

  return (
    <div className="dropdown-container">
      <h2 className="title">{title}</h2>
      {options.length > 0 && (
        <div>
          <Select
            placeholder="Odabir udaljenog certifikata.."
            value={selectedOption}
            onChange={handleChange}
            options={options}
          />
          <input
            className="password-input"
            type="password"
            placeholder="PIN"
            onChange={handleInputChange}
          />
          <div className="button-wrapper">
            <button
              className="button-style"
              disabled={password.length <= 5 || !selectedOption}
              onClick={handleOnClick}
            >
              Nastavi
            </button>
            <button className="button-style" onClick={handleCloseModal}>
              Zatvori
            </button>
          </div>
        </div>
      )}
      {options.length <= 0 && (
        <div className="button-wrapper">
          <p>Nemate udaljenih certifikata</p>
          <button className="button-style" onClick={handleCloseModal}>
            Zatvori
          </button>
        </div>
      )}
    </div>
  );
};

export default CloudCertDropdown;
